import { QUOTA_EXCEEDED, QUOTA_DISMISSED } from '../../api/types';

const initialState = {
  open: false,
  lastExceededAt: null,
  featureId: null,
  cost: null,
  balance: null,
};

export default function quotaReducer(state = initialState, action = {}) {
  switch (action.type) {
    case QUOTA_EXCEEDED: {
      const payload = action.payload || {};
      return {
        open: true,
        lastExceededAt: Date.now(),
        featureId: payload.featureId || null,
        cost: payload.cost ?? null,
        balance: payload.balance ?? null,
      };
    }
    case QUOTA_DISMISSED:
      return { ...state, open: false };
    default:
      return state;
  }
}
